import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';

import { UserRole } from '~/apps/shared/consts';
import SideSubMenu from '~/common/menu/SideSubMenu';


function SettingsSubMenuContainer(props) {
  const { auth, route } = props;

  let items = [
    {
      text: 'Account',
      isActive: route.name.startsWith('sender.settings.account'),
      onClick: (e) => navigate('sender.settings.account'),
    },
    {
      text: 'Support',
      isActive: route.name.startsWith('sender.settings.support'),
      onClick: (e) => navigate('sender.settings.support'),
    },
  ];

  if (auth.currentUser && auth.currentUser.role == UserRole.AGENT) {
    items.push({
      text: 'Team',
      isActive: route.name.startsWith('sender.settings.team'),
      onClick: (e) => navigate('sender.settings.team'),
    });
    items.push({
      text: 'Legal',
      isActive: route.name.startsWith('sender.settings.legal'),
      onClick: (e) => navigate('sender.settings.legal'),
    });
   }

  items.push({
    text: 'Logout',
    isActive: route.name.startsWith('logout'),
    onClick: (e) => navigate('logout'),
  });

  return (
    <SideSubMenu items={items} />
  );
}


const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('sender');

  return {
    auth: state.shared.auth,
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(SettingsSubMenuContainer);
